namespace Solovis.InvDataSelectors {

    export class CurrencySelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public selectionCallback;
        public cancelCallback;
        public selectedCurrency;

        public _filterListControl;
        public _availableHeight;

        public _currencyList;

        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
            this.selectedCurrency = options.initialValue ? options.initialValue : null;
        }

        public async doInitAsync(): Promise<void> {            
            let response = await this._portalServices.reportDataLoader().loadDataSetAsync(
                "/Solovis/Metadata/ModelEnvironment",
                { currencyOptions: { loadAll: true } });
                                
            var modelEnv = new InvData.ModelEnvironment();
            modelEnv.mergeEnvironmentData(response.result.dataSet.modelEnvironment);
            this._currencyList = modelEnv.currencies.itemList;
        }

        public setAvailableHeight(overallHeight) {
            var self = this;

            if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
                this._filterListControl.setAvailableHeight(overallHeight);
            }
            else {
                // The control is still rendering, so we will store the overallHeight and defer until the render is complete
                this._availableHeight = overallHeight;
            }
        }

        public doRender() {
            var self = this;

            var selectorControlHostDiv = $("<div>")
                .addClass("solovis-input")
                .appendTo(this.container);

            var currencyFilter = function (itemList, filterOptions) {
                var resultList = [];

                var queryTextLower = filterOptions.queryText.toLowerCase();
                $(itemList).each(function (index, item: any) {

                    var labelMatch = -1;
                    var codeMatch = -1;

                    var itemLabelLower = "";
                    var itemCodeLower = "";
                    if (item.label) {
                        itemLabelLower = item.label.toLowerCase();
                        labelMatch = itemLabelLower.indexOf(queryTextLower);
                    }
                    if (item.code) {
                        itemCodeLower = item.code.toLowerCase();
                        codeMatch = itemCodeLower.indexOf(queryTextLower);
                    }

                    if (labelMatch !== -1 || codeMatch !== -1) {
                        var matchPriority;

                        if (codeMatch === 0) {
                            matchPriority = 3;
                        }
                        else if (labelMatch === 0) {
                            matchPriority = 2;
                        }
                        else {
                            matchPriority = 1;
                        }

                        resultList.push({
                            matchPriority: matchPriority,
                            item: item,
                            labelLower: itemCodeLower + " - " + itemLabelLower
                        });
                    }
                });

                function compare(a, b) {
                    if (a.matchPriority > b.matchPriority) {
                        return -1;
                    }
                    if (a.matchPriority < b.matchPriority) {
                        return 1;
                    }
                    if (a.labelLower < b.labelLower) {
                        return -1;
                    }
                    if (a.labelLower > b.labelLower) {
                        return 1;
                    }

                    return 0;
                }

                return resultList.sort(compare);
            }

            var currencyItemDivGenerator = function (itemHolder, filterOptions) {
                var itemDiv = $("<div>")
                    .text(itemHolder.item.code + " - " + itemHolder.item.label);

                var isSelectedItem = false;
                var selectedItem = self.selectedCurrency;
                if (selectedItem) {
                    isSelectedItem = true;
                    for (var property in selectedItem) {
                        if (selectedItem.hasOwnProperty(property)) {
                            if (selectedItem[property] !== itemHolder.item[property]) {
                                isSelectedItem = false;
                            }
                        }
                    }
                }

                if (isSelectedItem) {
                    itemDiv.addClass("active");
                }

                return itemDiv;
            }

            this._filterListControl = new Solovis.UI.StringFilterListControl({
                controlHost: selectorControlHostDiv,
                listItems: this._currencyList,
                listFilter: currencyFilter,
                itemDivGenerator: currencyItemDivGenerator,
                selectedItem: self.selectedCurrency
            });

            $(this._filterListControl)
                .on("selectionChanged", function () {
                    var selectedItem = self._filterListControl.getSelectedItem();
                    self.selectionCallback(selectedItem);
                })
                .on("escapeKey", function () {
                    if (self.cancelCallback) {
                        self.cancelCallback();
                    }
                });

            this._filterListControl.setAsCurrentControl();

            this._filterListControl.focusFilter();

            if (this._availableHeight) {
                this._filterListControl.setAvailableHeight(this._availableHeight);
                this._availableHeight = null;
            }
            this._filterListControl.scrollToSelectedItem();
        }
        
    }

}
